package br.com.vvrefeicoes.portal.domain.model

enum class AuditResult {
    SUCCESS,
    FAILURE,
    NONE,
}
